/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountCredentialsForNagios extends models.ServiceAccountCredentialsForBasicAuth {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountCredentialsForNagios");
    }

    getFixupPrototypeFunction() { return ServiceAccountCredentialsForNagios.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountCredentialsForNagios>): ServiceAccountCredentialsForNagios {
        let obj = Object.assign(new ServiceAccountCredentialsForNagios(), model);
        ServiceAccountCredentialsForNagios.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountCredentialsForNagios>): ServiceAccountCredentialsForNagios {
        if (!model) return null;
        return ServiceAccountCredentialsForNagios.newInstance(<ServiceAccountCredentialsForNagios> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountCredentialsForNagios) {
        if (!obj) return;

        models.ServiceAccountCredentialsForNagios.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountCredentialsForNagios): boolean {
        if (models.ServiceAccountCredentialsForBasicAuth.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountCredentialsForNagios.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
